import AppRecord from './AppRecord.js'
import LossWarningNotification from './LossWarningNotification.js'
import APP from '../../../main.js'

class LossWarning extends AppRecord {
  get entity(){
    return this.constructor.employeeStore.entitiesById.get(this.entity_id)||{}
  }
  get investment(){
    return this.constructor.employeeStore.investments.find(ev => ev.id === this.investment_id)||{}
  }
  get asset_class(){
    return this.investment.asset_class
  }
  set notifications(array){
    this._notifications = array.map(item => new LossWarningNotification(item))
  }
  get notifications(){
    return this._notifications
  }
}

export default LossWarning
